import { Injectable } from '@angular/core';
import {
  AbstractControlOptions,
  UntypedFormArray,
  Validators,
} from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PledgeProductRead } from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import FormGroupArray from '@app/forms/subscription/services/FormGroupArray';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generateForm(entity: PledgeProductRead & { parameters: any }) {
    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<PledgeProductRead & { parameters: any }> = {
      id: [entity.id],
      type: [entity.type],
      productId: [entity.productId],
      productName: [entity.productName],
      status: [entity.status],
      parameters: this.formBuilder.group({
        operation: [
          entity?.parameters?.operation || 'VERSEMENT_COMPLEMENTAIRE',
        ],
        supportsInvestment: [entity?.parameters?.supportsInvestment || null],
        supportsInvestmentTotalAmount: [
          !_.isNil(entity?.parameters?.supportsInvestment?.totalAmount)
            ? entity?.parameters?.supportsInvestment?.totalAmount
            : null,
          Validators.required,
        ],
      }),
    };

    return this.formBuilder.group(formConfig, options);
  }
  generate(entity: any, option) {
    return FormGroupArray.generate({
      entity,
      options: option,
      formBuilder: this.formBuilder,
      generateForm: this.generateForm.bind(this),
      propertyName: 'products',
    });
  }

  get products() {
    return this.form.get('products') as UntypedFormArray;
  }

  floorValue(value: number) {
    return Math.floor(value * 100) / 100;
  }

  get suffixInput() {
    const operation = this.products
      .get(`${0}`)
      .get('parameters')
      .get('operation').value;

    return operation === 'VERSEMENT_PROGRAMME' ? '€/mois' : '€';
  }

  extract() {
    const formValue = _.cloneDeep(this.form?.value?.products);
    formValue?.forEach(item => {
      if (!item?.parameters?.supportsInvestment) {
        item.parameters.supportsInvestment = {
          totalAmount: null,
          supportRepartition: [],
        };
      }

      item.parameters.supportsInvestment.totalAmount =
        item.parameters.supportsInvestmentTotalAmount;
    });
    return formValue;
  }
}
